import { useEffect } from 'react';
var Seo = function (_a) {
    var title = _a.title, description = _a.description, image = _a.image, url = _a.url;
    useEffect(function () {
        var metaDescription = document.querySelector('meta[name="description"]');
        var metaImage = document.querySelector('meta[name="image"]');
        var metaUrl = document.querySelector('meta[name="url"]');
        document.title = "".concat(title, " - Majeures");
        if (metaDescription && description) {
            metaDescription.setAttribute('content', description);
        }
        if (metaImage && image) {
            metaImage.setAttribute('content', image);
        }
        if (metaUrl && url) {
            metaUrl.setAttribute('content', url);
        }
    }, [title, description, image, url]);
    return null;
};
export default Seo;
